import { Select, SelectOptions } from '@opten/select';

import { hasClass } from '@opten/dom/has-class';

export class CourseForm {
    private $element: JQuery;
    private $teamMember: JQuery;
    private $teamMemberTemplate: JQuery;
    private $teamMemberWrapper: JQuery;
    private $addTeamMember: JQuery;
    private $removeTeamMember: JQuery;
    private maxParticipantsData: number;

    constructor(private element: HTMLElement) {
        this.$element = $(element);
        this.$teamMemberWrapper = this.$element.find(
            '.js-course-form-team-member-elements'
        );

        this.$addTeamMember = this.$element.find(
            '.js-course-form-add-team-member'
        );
        this.$removeTeamMember = this.$element.find(
            '.js-course-form-remove-team-member'
        );
        this.maxParticipantsData = this.$element
            .closest('.js-course-form-wrapper')
            .data('max-participants');

        if(this.maxParticipantsData > 0){
            this.maxParticipantsData = this.maxParticipantsData - 1; //main member is a participant as well
        }

        this.init();

        $(document).on('click', '.js-course-form-add-team-member', e => {
            e.preventDefault();
            if (
                $(e.target)
                    .closest('a')
                    .hasClass('--disabled') === false
            ) {
                const template = document.getElementById(
                    'js-course-form-team-member-template'
                );

                $(template.innerHTML).appendTo(this.$teamMemberWrapper);
                this.updateIdentifiers();
                this.updateAddButton();
                this.updateForm();
                this.reinitSelect(this.$teamMemberWrapper);
            }
        });

        $(document).on('click', '.js-course-form-remove-team-member', e => {
            e.preventDefault();
            $(e.target)
                .closest('.js-course-form-team-member')
                .first()
                .remove();
            this.updateIdentifiers();
            this.updateAddButton();
            this.updateForm();
        });
    }

    public init(): void {
        this.updateAddButton();
        this.updateForm();
    }

    public updateAddButton() {
        this.$addTeamMember.removeClass('--disabled');

        let maxParticipants = this.maxParticipantsData;

        if (maxParticipants > 0) {
            maxParticipants =
                maxParticipants -
                this.$element.find('.js-course-form-team-member').length;

            if (maxParticipants <= 0) {
                this.$addTeamMember.addClass('--disabled');
            }
        }
    }

    public updateForm() {
        $('form').removeData('validator');
        $.validator.unobtrusive.parse(document);
    }

    public reinitSelect(parent: JQuery) {
        let selects = Array.from(parent.find('select.js-select'));
        selects = selects.filter(select => select.nextElementSibling === null || hasClass(select.nextElementSibling, 'js-select') === false);
        selects.forEach(element => new Select(element as HTMLSelectElement, {
			classes: {
				component: 'c-select',
				active: '--active',
				highlighted: '--highlighted',
				disabled: '--disabled',
				iconHtml: ''
			}
		} as SelectOptions));
    }

    public updateIdentifiers(
        toReplace: string = 'input,textarea,select,label,span'
    ) {
        const $teamMember = this.$element.find('.js-course-form-team-member');
        if ($teamMember != null && $teamMember.length > 0) {
            $teamMember.each((index, elem) => {
                let that = $(elem);
                that.find('.js-course-form-team-member-index').text(index + 1);
                that.find(toReplace).each((itemIndex, item) => {
                    let $item = $(item);
                    if ($item.attr('for')) {
                        $item[0].setAttribute(
                            'for',
                            $item
                                .prop('for')
                                .replace(/\[(.+?)\]/g, '[' + index + ']')
                        );
                    }
                    if ($item.attr('name')) {
                        $item[0].setAttribute(
                            'name',
                            $item
                                .prop('name')
                                .replace(/\[(.+?)\]/g, '[' + index + ']')
                        );
                    }
                    if ($item.attr('id')) {
                        $item[0].setAttribute(
                            'id',
                            $item
                                .prop('id')
                                .replace(/\[(.+?)\]/g, '[' + index + ']')
                        );
                    }
                    if ($item.data('valmsg-for')) {
                        $item.data(
                            'valmsg-for',
                            $item
                                .data('valmsg-for')
                                .replace(/\[(.+?)\]/g, '[' + index + ']')
                        );
                        $item.attr('data-valmsg-for', $item.data('valmsg-for'));
                    }
                    if ($item.attr('aria-describedby')) {
                        $item.attr(
                            'aria-describedby',
                            $item
                                .attr('aria-describedby')
                                .replace(/\[(.+?)\]/g, '[' + index + ']')
                        );
                        $item.attr(
                            'aria-describedby',
                            $item
                                .attr('aria-describedby')
                                .replace(/\\\[(.+?)\\\]/g, '[' + index + ']')
                        );
                        $item.attr(
                            'aria-describedby',
                            $item
                                .attr('aria-describedby')
                                .replace(/\\\[(.+?)\]/g, '[' + index + ']')
                        );
                        $item.attr(
                            'aria-describedby',
                            $item
                                .attr('aria-describedby')
                                .replace(/\[(.+?)\\\]/g, '[' + index + ']')
                        );
                    }
                });
            });
        }
    }
}

export default function courseForm(element: HTMLElement): CourseForm {
    return new CourseForm(element);
}
